import React, { useState } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Pricing from './components/Pricing/Pricing';
import Footer from './components/Footer/Footer';

function App() {
  const [activeService, setActiveService] = useState(null);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Services activeService={activeService} setActiveService={setActiveService} />
      <Pricing />
      <Footer />
    </div>
  );
}

export default App;
